import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Button } from "@zapier/design-system";
export const UpgradeButton = ({ href, onClick = () => {
}, text = "Upgrade plan", }) => {
    if (!href && !onClick) {
        console.error("UpgradeButton: Either an `href` or `onClick` prop is required.");
        return null;
    }
    return (_jsx(Button, { onClick: onClick, ...(href ? { href } : {}), children: text }));
};

// @zapier/upsells@8.0.1 (466b4077f)
